(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/react/pages/actiontypes.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/react/pages/actiontypes.js');
"use strict";


const SET_BRANDING = 'pages.SET_BRANDING';
svs.tickets_giftshop.pages.actiontypes = {
  SET_BRANDING
};

 })(window);